/* Conciencia de Exposicion page behaviour: gallery, offer cards, tabs, sticky CTA.
   Everything is queried inside .ex-scope so this cannot touch other templates.
   No custom elements are defined here - the published theme already declares the
   full Dawn set, and re-declaring any of them throws
   "Identifier 'X' has already been declared" and kills every script on the page. */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var scope = document.querySelector('.ex-scope');
    if (!scope) return;

    /* ---- gallery ---- */
    var main = document.getElementById('ex-main-image');
    var thumbs = document.querySelectorAll('.ex-gallery__thumbs img');
    Array.prototype.forEach.call(thumbs, function (t) {
      t.addEventListener('click', function () {
        var full = t.getAttribute('data-full');
        if (main && full) main.src = full;
        Array.prototype.forEach.call(thumbs, function (o) { o.classList.remove('is-active'); });
        t.classList.add('is-active');
      });
    });

    /* ---- offer cards: keep the hidden variant input and the prices in sync ---- */
    var offers = document.querySelectorAll('.ex-offer');
    var idInput = document.getElementById('ex-variant-id');
    var priceEl = document.getElementById('ex-price');
    var wasEl = document.getElementById('ex-price-was');
    var atcPrice = document.getElementById('ex-atc-price');
    var stickyPrice = document.getElementById('ex-sticky-price');

    function selectOffer(card) {
      Array.prototype.forEach.call(offers, function (o) { o.classList.remove('is-active'); });
      card.classList.add('is-active');
      var radio = card.querySelector('input[type="radio"]');
      if (radio) radio.checked = true;
      if (idInput && card.dataset.variantId) idInput.value = card.dataset.variantId;

      var p = card.dataset.price || '';
      var was = card.dataset.compare || '';
      if (priceEl && p) priceEl.textContent = p;
      if (wasEl) {
        if (was && was !== p) { wasEl.textContent = was; wasEl.hidden = false; }
        else wasEl.hidden = true;
      }
      /* Only append a figure to the button when there is a real one. With no
         price set the button keeps its plain label instead of reading "- $0.00". */
      Array.prototype.forEach.call([atcPrice, stickyPrice], function (el) {
        if (!el) return;
        if (p) { el.textContent = ' - ' + p; el.hidden = false; }
        else { el.textContent = ''; el.hidden = true; }
      });
    }

    Array.prototype.forEach.call(offers, function (card) {
      card.addEventListener('click', function () { selectOffer(card); });
    });
    var preselected = document.querySelector('.ex-offer.is-active');
    if (preselected) selectOffer(preselected);

    /* ---- tabs ---- */
    var tabs = document.querySelectorAll('.ex-tabs__tab');
    Array.prototype.forEach.call(tabs, function (tab) {
      tab.addEventListener('click', function () {
        var target = tab.dataset.panel;
        Array.prototype.forEach.call(tabs, function (t) { t.classList.remove('is-active'); });
        tab.classList.add('is-active');
        var panels = document.querySelectorAll('.ex-tabs__panel');
        Array.prototype.forEach.call(panels, function (p) {
          p.classList.toggle('is-active', p.dataset.panel === target);
        });
      });
    });

    /* ---- "ver tabla nutricional" jumps to the ingredients tab ---- */
    var factsLink = document.getElementById('ex-facts-link');
    if (factsLink) {
      factsLink.addEventListener('click', function (e) {
        e.preventDefault();
        var t = document.querySelector('.ex-tabs__tab[data-panel="ingredientes"]');
        if (t) { t.click(); t.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
      });
    }

    /* ---- sticky CTA: show once the main buy button has scrolled away ---- */
    var sticky = document.getElementById('ex-sticky');
    var atc = document.getElementById('ex-add');
    if (sticky && atc) {
      var onScroll = function () {
        var r = atc.getBoundingClientRect();
        sticky.classList.toggle('is-on', r.bottom < 0);
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
    var stickyBtn = document.getElementById('ex-sticky-add');
    if (stickyBtn && atc) {
      stickyBtn.addEventListener('click', function () { atc.click(); });
    }
  });
})();
